export class UtilityConstants {
  static readonly MILLISECONDS_IN_SECOND = 1000;
  static readonly SECONDS_IN_MINUTE = 60;
  static readonly MINUTES_IN_DAY = 1440;
  static readonly MINUTES_IN_31_DAY_MONTH = UtilityConstants.MINUTES_IN_DAY * 31;
  static readonly MINUTES_IN_YEAR = 525600;
  static readonly HOURS_IN_DAY = 24;
  static readonly HOURS_IN_YEAR = 8760;
  static readonly DAYS_IN_MONTHS = new Map([[31, 1], [62, 2], [93, 3], [124, 4], [155, 5], [186, 6], [217, 7], [248, 8],
    [279, 9], [310, 10], [341, 11], [365, 12]]);
}

export const sessionTokenKey = "_xypz";
export const userIdKey = "_yhzjh";
export const KEEP_RETURN_URL_ON_START_UP = "kruos";

export const APP_WEBVIEW_PHONE_PARAMETER = "awvp";
export const APP_WEBVIEW_MASKED_EMAIL = "awvme";
export const APP_WEBVIEW_HIDE_SHARE_APP_OPTION = "hsao";
export const APP_WEBVIEW_APP_VERSION = "awvav";
export const IS_IN_WEBVIEW_KEY = "inAppWebview";
export const SIGNUP_SUCCESS_OLD_APP_SUPPORT_PARAMETER_KEY = "ssoas";

export const GUEST_PARKING_ZONE_NAME_PARAMETER = "z";
export const GUEST_PARKING_URL = "guestparking";

// Note: If some of these regexes are updated here, they should also be updated in the backend constants and vice versa
export const UsernamePattern = "^[a-zA-Z0-9_.*£&$%&!£@#^()<>{}\\/'+[\\])]+$";
export const PayStay_MobileNumber_Regex = /(?:^(614)\d{8}$|^(04)\d{8}$)/g;
export const ATPARK_MobileNumber_Regex = /(?:^(642)\d{7,9}$|^(02)\d{7,9}$)/g;
export const First_Name_Regex = /^[a-zA-Z0-9'@#$&*+\\-_,+:?.,!\\s\\/ ]*$/;
export const Vehicle_Regex = /^[a-zA-Z0-9]{0,20}$/;
export const Alphanumeric_Regex = /^[a-zA-Z0-9 \-\/&\+@.,\?]*$/;
export const Email_Regex = /^[a-zA-Z0-9_\+\-'!$#%&*=\/?^{}\\|~]+(\.[a-zA-Z0-9_\+\-'!$#%&*=\/?^{}\|~]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.([a-zA-Z]+)$/;

export const INTEGER_32_MAX = Math.pow(2,31) - 1;

export const idmOidcProviderClaimKey = "Ext_provider";

export const SHOW_HEADER_BAR: string = "showHeaderBar";
export const SHOW_HEADER_BAR_KEY = "showHeaderBar";
export const SHOW_HEADER_KEY = "showHeader";
export const SHOW_DOWNLOAD_PAYSTAY_KEY = "showDownloadPayStayBar";
export const SHOW_PAYSTAY_FOOTER_KEY = "showPayStayFooterBar";
export const SHOW_ANDROID_SMART_BANNER = "showAndroidSmartBanner";

export const ZONE_NAME_URL_PARAM = "zoneName";
export const METER_ID_URL_PARAM = "meterId";
export const INITIALISATION_TYPE_URL_PARAM = "initialisationType";

export const CLIENT_IDENTIFIER_PARAMETER_KEY = "client";
export const CLIENT_IDENTIFIER_LOCAL_STORAGE_KEY = "C_Identifier";



export const FireBaseEvents = {
  EXTEND: {
    LOADED: "omni_extend_loaded",
    COMPLETED: "omni_extend_completed",
  },
  INITIAL: {
    LOADED: "omni_initial_loaded",
    COMPLETED: "omni_initial_completed",
    PHONE_NUMBER_IN_URL: "omni_initial_phone_number_in_url", // Text2Park or NFC initiated
  },
  POSTPAY: {
    LOADED: "omni_postpay_loaded",
    COMPLETED: "omni_postpay_completed",
  },
  PAYMENT: {
    SUCCESS: "omni_payment_success",
    FAILURE: "omni_payment_failure",
    DROP_IN_LOADED: "windcave_drop_in_loaded",
    DROP_IN_ERROR: "windcave_drop_in_error",
  },
  RECEIPT: {
    DOWNLOAD_SUCCESS: "omni_receipt_download_success",
    DOWNLOAD_ERROR: "omni_receipt_download_error",
    EMAIL_SUCCESS: "omni_receipt_email_success",
    EMAIL_ERROR: "omni_receipt_email_error",
  }
}

export const NO_PHONE_NUMBER_ATTACHED = "-1";
export const DEFAULT_MAX_PLATE_LENGTH = 10;
export const VIEW_RATES_ICON = `          
<svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 15.1826C3.92041 15.1826 0.529297 11.7915 0.529297 7.71191C0.529297 3.625 3.91309 0.241211 7.99268 0.241211C12.0796 0.241211 15.4707 3.625 15.4707 7.71191C15.4707 11.7915 12.0869 15.1826 8 15.1826ZM8 13.9375C11.457 13.9375 14.2256 11.1689 14.2256 7.71191C14.2256 4.25488 11.4497 1.48633 7.99268 1.48633C4.53564 1.48633 1.78174 4.25488 1.78174 7.71191C1.78174 11.1689 4.54297 13.9375 8 13.9375ZM7.93408 5.17773C7.40674 5.17773 6.98193 4.75293 6.98193 4.21826C6.98193 3.68359 7.40674 3.25879 7.93408 3.25879C8.46875 3.25879 8.88623 3.68359 8.88623 4.21826C8.88623 4.75293 8.46875 5.17773 7.93408 5.17773ZM6.71826 11.8135C6.41797 11.8135 6.18359 11.5938 6.18359 11.2935C6.18359 11.0078 6.41797 10.7808 6.71826 10.7808H7.62646V7.42627H6.84277C6.54248 7.42627 6.30811 7.20654 6.30811 6.90625C6.30811 6.62061 6.54248 6.39355 6.84277 6.39355H8.21973C8.59326 6.39355 8.79102 6.65723 8.79102 7.05273V10.7808H9.69922C9.99951 10.7808 10.2339 11.0078 10.2339 11.2935C10.2339 11.5938 9.99951 11.8135 9.69922 11.8135H6.71826Z"
  fill="var(--color-primaryColor)" />
</svg>`

export const DISCLAIMER_TEXT = "*Excludes reminder fee if applicable";
export const DEFAULT_DISPLAY_PAYMENT_DISCLAIMER: boolean = true;

export const NON_PAYMENT_SESSION_EXPIRED_MESSAGE = "You've been inactive for a while. Please refresh the app to continue.";
export const PAYMENT_SESSION_EXPIRED_MESSAGE = "Your payment session has timed out. For your security, please refresh to continue with payment.";

export const DISCLAIMER_TEXT_PHONE_PAYMENT = "By submitting your mobile phone number and paying for your parking session, you agree to PayStay's ";

export const OTHER_SESSIONS_FOUND_DEFAULT_MESSAGE = "There is already an active plate<br>in use with this TAP card.";
export const BLACKLIST_DEFAULT_MESSAGE = "This card is not allowed to be used for parking.";
export const VIOLATOR_VIOLATIONS_DEFAULT_MESSAGE = "This card has parking violations. Please ensure you comply.";

export const DEFAULT_PERMIT_CODE_LENGTH = 10;